import { Injectable } from '@angular/core';
import { DataStateChangeEventArgs, DataSourceChangedEventArgs } from '@syncfusion/ej2-angular-grids';
import { HttpBackend, HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';
import { LocalStorageService } from '../localStorage/local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class AmcService  extends Subject<DataStateChangeEventArgs>  {
  private httpClient: HttpClient;
  constructor(private handler: HttpBackend,
    private http: HttpClient, 
    private storageService: LocalStorageService,
    ) { 
      super();
      this.httpClient = new HttpClient(handler);
    }

    handleError(error: HttpErrorResponse) {
      let errorMessage = '';
      if (error.error instanceof ErrorEvent) {
        errorMessage = `Error: ${error.error.message}`;
      } else {
        errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
      }
      //  window.alert(errorMessage);
    console.log("Error:",errorMessage);
    return throwError(errorMessage);
    }

       // Create AnnualMaintenanceContracts
      createAnnualMaintenanceContracts(user: Object): Observable<Object> {
        console.log("In annualMaintenanceContracts method, annualMaintenanceContracts: ", user);
        return this.http.post(`${environment.apiUrl}/annualMaintenanceContracts`, user).pipe(catchError(this.handleError));
      }

      // Get AnnualMaintenanceContracts by Id Get
      getAnnualMaintenanceContracts(id: number): Observable<Object> {
        return this.http.get(`${environment.apiUrl}/annualMaintenanceContracts/${id}`).pipe(catchError(this.handleError));
      }


      //Delete AnnualMaintenanceContracts by Id Delete
      deleteAnnualMaintenanceContracts(id: number): Observable<Object> {
        return this.http.delete(`${environment.apiUrl}/annualMaintenanceContracts/${id}`).pipe(catchError(this.handleError));
        }

      //Update AnnualMaintenanceContracts by Id Put
      updateAnnualMaintenanceContracts(user: Object,id: number): Observable<Object> {
        console.log("In createUser method, user: ", user);
        return this.http.put(`${environment.apiUrl}/annualMaintenanceContracts/${id}`, user).pipe(catchError(this.handleError));
        }

      //Get All AnnualMaintenanceContracts 
      getAllAnnualMaintenanceContracts(): Observable<Object> {
        return this.http.get(`${environment.apiUrl}/annualMaintenanceContracts`).pipe(catchError(this.handleError));
        }
}
